import { authorizedAxios } from '../../axiosInstances';

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api`;
const version = 'v2';
const main = 'PricingEngine';
const sub = 'LockDesk';

class LockDeskService {
  checkLockDeskAdmin() {
    return authorizedAxios
      .get(`${API_URL}/${version}/${main}/${sub}/CheckLockDeskAdmin`)
      .then((response) => {
        return response;
      });
  }
}

export default new LockDeskService();
